export enum Routes {
  UserType = 'user/type',
}
